import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Confetti from 'react-confetti';
import BadgePreviewModal from './BadgePreviewModal';
import './Modal.css';

const PostScoreModal = ({ currentUser, timeCompleted, theme, gameId, placement }) => {
  const navigate = useNavigate();
  const [showCelebration, setShowCelebration] = useState(true);
  const [showConfetti, setShowConfetti] = useState(true);
  const [windowDimensions, setWindowDimensions] = useState({ width: 0, height: 0 });
  const [showBadgePreview, setShowBadgePreview] = useState(false);
  
  console.log('PostScoreModal rendered with:', { currentUser, timeCompleted, theme, gameId, placement });

  // Set window dimensions for confetti
  useEffect(() => {
    const updateWindowDimensions = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    updateWindowDimensions();
    window.addEventListener('resize', updateWindowDimensions);

    return () => window.removeEventListener('resize', updateWindowDimensions);
  }, []);


  // Stop confetti after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowConfetti(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);


  const handleCloseModal = () => {
    console.log('User clicked close, navigating to leaderboard');
    setShowCelebration(false);
    // Navigate to leaderboard
    navigate('/leaderBoard?scrollToLatest=true');
  };

  const handleViewBadge = () => {
    setShowBadgePreview(true);
  };

  const handleCloseBadgePreview = () => {
    setShowBadgePreview(false);
  };

  const handleNavigateToLeaderboard = () => {
    navigate('/leaderBoard?scrollToLatest=true');
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return mins > 0 ? `${mins}m ${secs}s` : `${secs}s`;
  };



  return (
    <div className="modal-overlay">
      {showConfetti && (
        <Confetti
          width={windowDimensions.width}
          height={windowDimensions.height}
          recycle={false}
          numberOfPieces={300}
          colors={['#ff69b4', '#00ff00', '#8a2be2', '#ffd700', '#ff1493']}
        />
      )}
      
      <div className="modal post-score-modal">
        {showCelebration && !showBadgePreview && (
          <button 
            className="close-btn"
            onClick={handleCloseModal}
            title="View Leaderboard"
          >
            ✕
          </button>
        )}
        <h1 className="good-job">
          <div>🎉 Congratulations,</div>
          <div>{currentUser || 'Player'}! 🎉</div>
        </h1>
        
        <div className="post-score-body">
          <div className="score-celebration">
            <h2>Time Completed:</h2>
            <div className="score-display">
              <span className="time-span">{formatTime(timeCompleted || 0)}</span>
            </div>
            {placement && (
              <div className="placement-info">
                <h3>🏆 You achieved #{placement} place!</h3>
              </div>
            )}
          </div>
          
        </div>
        
        <div className="post-score-buttons">
          <button 
            className="share-score-btn"
            onClick={handleViewBadge}
            disabled={!gameId}
          >
            🏆 View Badge
          </button>
        </div>
      </div>
      
      <BadgePreviewModal
        isOpen={showBadgePreview}
        onClose={handleCloseBadgePreview}
        gameId={gameId}
        onNavigateToLeaderboard={handleNavigateToLeaderboard}
      />
    </div>
  );
};

export default PostScoreModal; 